import { fabric } from 'fabric';
import { useEffect } from 'react';
import { StitchingManipulationRules, getStitchingManipulationRulesFromActiveSelection } from '../../../../shared/Helpers';

interface IObjectOptions extends fabric.IObjectOptions {
  canvas: fabric.Canvas;
}

function useCanvasSelectAll(canvasEl: Nullable<fabric.Canvas>, selectAll: boolean) {
  useEffect(() => {
    if (canvasEl && selectAll) {
      canvasEl.discardActiveObject();
      const activeObject = canvasEl.getObjects().filter(x => x.visible);
      const objOptions: IObjectOptions = {
        canvas: canvasEl,
        ...getStitchingManipulationRulesFromActiveSelection(activeObject)
      };
      var sel = new fabric.ActiveSelection(
        canvasEl.getObjects().filter(x => x.visible),
        objOptions
      );
      canvasEl.setActiveObject(sel);
      canvasEl.requestRenderAll();
    }
  }, [canvasEl, selectAll]);
}

export default useCanvasSelectAll;
